// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"01ec29c1","112":"771b38d4","453":"79a6a59e","461":"3e252ba4","526":"255b62ff","576":"ec0e86b1","694":"06e1d003","718":"e285d072","885":"58bc3440","900":"4910bd1b","931":"7217ca19"}[chunkId] + ".chunk.js";
};